<div class="flex items-start gap-1.5 flex-1 min-w-0">
  @if (showSeq()) {
    <span
      class="w-5 h-5 rounded-full bg-surface-700 text-white flex items-center justify-center text-body-2xs-700 shrink-0"
    >
      {{ dealAddendum().seq }}
    </span>
  }
  <div class="flex gap-2 items-start flex-1 flex-wrap sm:flex-nowrap">
    <div class="flex flex-col gap-1.5 w-full min-w-0">
      <div class="flex items-start flex-nowrap md:flex-wrap gap-2 leading-none">
        <div class="flex items-center gap-1 min-w-0 flex-1 md:flex-initial">
          <h5
            class="text-body-600 text-surface-700 m-0 leading-5 md:leading-none min-w-0 break-words"
            [class.!text-surface-500]="dealAddendum().isCancelled"
            [class.line-through]="dealAddendum().isCancelled"
          >
            {{ dealAddendum().builderReference.reference }}
          </h5>
          @if (showActions() && canEditBuilderReference()) {
            <span
              class="hidden md:inline-flex cursor-pointer text-amber-500 items-center justify-center shrink-0"
              role="button"
              pTooltip="Edit Builder Reference"
              tooltipPosition="top"
              (click)="openEditBuilderReferenceModal($event)"
            >
              <i class="pi pi-pen-to-square text-[12px] leading-none"></i>
            </span>
          }
        </div>
        <p-tag
          [value]="'Type: ' + dealAddendum().addendumType.name"
          size="small"
          severity="info"
          class="hidden md:inline-flex"
        />
        @if (dealAddendum().isCancelled) {
          <p-tag value="Cancelled" size="small" severity="danger" class="hidden md:inline-flex" />
        }
        @if (dealAddendum().buyerApproved && !showLocked()) {
          <span class="hidden md:inline-flex items-center gap-1 text-green-700">
            <i class="pi pi-check-circle text-body-xs"></i>
            <span class="text-body-xs-600">Buyer Approved</span>
          </span>
        }
        @if (dealAddendum().builderApproved && !showLocked()) {
          <span class="hidden md:inline-flex items-center gap-1 text-green-700">
            <i class="pi pi-check-circle text-body-xs"></i>
            <span class="text-body-xs-600">Builder Approved</span>
          </span>
        }
        @if (showLocked()) {
          <p-tag [value]="'Locked'" size="small" severity="secondary" icon="pi pi-lock" class="hidden md:inline-flex" />
        }
        <div class="md:hidden ml-auto shrink-0 flex items-center gap-2" (click)="$event.stopPropagation()">
          @if (showTotal()) {
            <span
              class="text-body-700 text-emerald-700 whitespace-nowrap leading-5"
              [class.!text-surface-500]="dealAddendum().isCancelled"
              [class.line-through]="dealAddendum().isCancelled"
            >
              {{ dealAddendum().total | currencyFormat }}
            </span>
          }
          @if (showTotal() && (showActions() || showExpandToggle())) {
            <div class="w-px h-4 bg-surface-200 shrink-0"></div>
          }
          <ng-container *ngTemplateOutlet="actionIcons" />
        </div>
      </div>

      @if (showLocked() || dealAddendum().isCancelled) {
        <div class="md:hidden flex items-center gap-2 text-body-xs text-surface-500">
          @if (showLocked()) {
            <span class="inline-flex items-center gap-1">
              <i class="pi pi-lock text-body-xs"></i>
              Locked
            </span>
          }
          @if (dealAddendum().isCancelled) {
            <p-tag value="Cancelled" size="small" severity="danger" />
          }
        </div>
      }

      <div class="flex gap-x-4 gap-y-1 flex-wrap items-center text-body-xs text-surface-500">
        @if (createdByName()) {
          <span>
            Created By: <span class="text-body-xs-600 text-surface-700">{{ createdByName() }}</span>
            @if (createdOn()) {
              on <span class="text-body-xs-600 text-surface-700">{{ createdOn() | date: 'h:mm a, MM/dd/yyyy' }}</span>
            }
          </span>
        }
      </div>

      @if (showSignOffStatus() && signOffSigners().length) {
        <div class="hidden md:flex gap-x-2 gap-y-1 flex-wrap items-center text-body-xs text-surface-500">
          <span>Sign-off Status:</span>
          @if (allSigned()) {
            <span class="text-body-xs-600 text-emerald-700">All Signed</span>
          } @else {
            @for (signer of signOffSigners(); track signer.id; let last = $last) {
              <span class="text-body-xs-500" [class]="signerChipClasses[signer.status]">
                @if (signerChipLabels[signer.status]; as statusLabel) {
                  {{ signerRoleLabels[signer.entityType] }} {{ statusLabel }}
                } @else {
                  Awaiting {{ signerRoleLabels[signer.entityType] }} Sign
                }
              </span>
              @if (!last) {
                <span class="text-surface-400">·</span>
              }
            }
          }
        </div>
      }

      @if (showSignOffStatus() && signOffCompletionDate()) {
        <div class="hidden md:block text-body-xs text-surface-500">
          Sign-off Completion:
          <span class="text-body-xs-600 text-surface-700">{{ signOffCompletionDate() | date: 'MM/dd/yyyy' }}</span>
        </div>
      }
    </div>
    @if (showTotal()) {
      <div class="hidden md:flex flex-col items-center gap-2 mr-[3px] whitespace-nowrap shrink-0 self-start">
        <span class="text-body-2xs text-surface-500 uppercase tracking-wide leading-none">Total</span>
        <span
          class="text-body-md-700 text-emerald-700 cursor-pointer whitespace-nowrap leading-none"
          [class.!text-surface-500]="dealAddendum().isCancelled"
          [class.line-through]="dealAddendum().isCancelled"
          [pTooltip]="totalBreakdownTooltip"
          tooltipPosition="top"
          tooltipStyleClass="dsm-total-breakdown-tooltip"
          appendTo="body"
        >
          {{ dealAddendum().total | currencyFormat }}
        </span>
      </div>
    }
  </div>
</div>

<div
  class="hidden md:flex items-center gap-3 z-10 absolute"
  [class]="actionRailAlign() === 'center' ? 'top-1/2 -translate-y-1/2 right-2' : 'top-4 right-4'"
  (click)="$event.stopPropagation()"
>
  @if (showTotal() && (showActions() || showExpandToggle())) {
    <div class="w-px h-6 bg-surface-200 shrink-0"></div>
  }
  <ng-template #totalBreakdownTooltip>
    <div class="flex flex-col gap-2 w-max p-2">
      <div class="flex justify-between items-center gap-3">
        <span class="whitespace-nowrap">Options</span>
        <span class="text-body-sm-500 whitespace-nowrap">{{ optionsTotal() | currencyFormat }}</span>
      </div>
      <div class="flex justify-between items-center gap-3">
        <span class="whitespace-nowrap">Taxes</span>
        <span class="text-body-sm-500 whitespace-nowrap">{{ taxesTotal() | currencyFormat }}</span>
      </div>
      <div class="flex justify-between items-center gap-3 text-emerald-300">
        <span class="inline-flex items-center gap-1.5 text-body-sm-500 whitespace-nowrap">
          <i class="pi pi-tag"></i>Discounts
        </span>
        <span class="text-body-sm-500 whitespace-nowrap">- {{ discountsTotal() | currencyFormat }}</span>
      </div>
      <div class="flex justify-between items-center gap-3 text-emerald-300">
        <span class="inline-flex items-center gap-1.5 text-body-sm-500 whitespace-nowrap">
          <i class="pi pi-gift"></i>Incentives
        </span>
        <span class="text-body-sm-500 whitespace-nowrap">- {{ incentivesTotal() | currencyFormat }}</span>
      </div>
    </div>
  </ng-template>
  <ng-container *ngTemplateOutlet="actionIcons" />
</div>

<ng-template #actionIcons>
  @if (showActions()) {
    <span
      class="inline-flex cursor-pointer text-surface-500 items-center justify-center"
      (click)="openOptionLogsModal()"
    >
      <i class="pi pi-info-circle text-body-sm leading-5 md:leading-none"></i>
    </span>
    @if (hasActionMenu()) {
      <span
        class="inline-flex cursor-pointer text-surface-500 items-center justify-center"
        (click)="openActionMenu($event)"
      >
        <i class="pi pi-ellipsis-v text-body-sm leading-5 md:leading-none"></i>
      </span>
    }
  }
  @if (showExpandToggle()) {
    <span
      class="inline-flex cursor-pointer text-surface-500 items-center justify-center"
      (click)="$event.stopPropagation(); toggleExpand.emit()"
    >
      <i
        class="pi text-body-sm leading-5 md:leading-none"
        [class.pi-chevron-up]="isExpanded()"
        [class.pi-chevron-down]="!isExpanded()"
      ></i>
    </span>
  }
</ng-template>

@if (showActions()) {
  <p-menu #actionMenu [model]="actionMenuItems()" [popup]="true" appendTo="body" />

  <!-- Logs dialog -->
  <p-dialog
    header="Addendum activity logs"
    [visible]="logsDialogVisible()"
    (visibleChange)="logsDialogVisible.set($event)"
    [modal]="true"
    [style]="{ width: '90vw', maxWidth: '720px' }"
    [appendTo]="'body'"
  >
    @if (logsDialogVisible()) {
      <dsm-addendum-logs [addendumId]="dealAddendum().id" />
    }
  </p-dialog>

  <p-dialog
    header="Edit Builder Reference"
    [visible]="isEditBuilderReferenceModalVisible()"
    (visibleChange)="isEditBuilderReferenceModalVisible.set($event)"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: '90vw', maxWidth: '480px' }"
    [appendTo]="'body'"
  >
    <form class="flex flex-col gap-4" [formGroup]="builderReferenceForm" (ngSubmit)="saveBuilderReference()">
      <generic-dropdown
        class="w-full"
        [items]="builderReferences()"
        [label]="'Builder Reference'"
        formControlName="builderReference"
        [allowSearch]="true"
        [clearable]="false"
        [required]="true"
        [errormessage]="'Builder Reference is required'"
        placeholder="Select Builder Reference"
      />
      <div class="flex justify-end gap-2">
        <p-button
          label="Cancel"
          severity="secondary"
          type="button"
          (onClick)="closeEditBuilderReferenceModal()"
          [disabled]="isSubmittingBuilderReference()"
        />
        <p-button label="Save" type="submit" [loading]="isSubmittingBuilderReference()" />
      </div>
    </form>
  </p-dialog>

  <!-- Guarded so the form (and its addendum-dropdown request) is only created when the dialog opens. -->
  @if (isReallocationModalVisible()) {
    <p-dialog
      [visible]="isReallocationModalVisible()"
      (visibleChange)="closeReallocationModal()"
      [modal]="true"
      [dismissableMask]="false"
      [closable]="true"
      [style]="{ width: '720px' }"
      [draggable]="false"
      [appendTo]="'body'"
    >
      <ng-template pTemplate="header">
        <div class="flex items-center gap-3 min-w-0">
          <span
            class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-amber-50 text-amber-700 shrink-0"
            aria-hidden="true"
          >
            <i class="pi pi-replay text-base font-bold"></i>
          </span>
          <div class="flex flex-col gap-0.5 min-w-0">
            <span class="font-semibold text-xl text-surface-800">Apply freed incentive to another addendum?</span>
            <span class="text-body-sm text-surface-500 truncate">
              Cancelling {{ dealAddendum().builderReference.reference }} released
              <span class="text-emerald-700 text-body-sm-600">{{ freedIncentiveAmount() | currencyFormat }}</span>
              back into the pool
            </span>
          </div>
        </div>
      </ng-template>

      <dsm-incentive-reallocation-form
        #reallocationForm
        [dealId]="dealId()"
        [freedAmount]="freedIncentiveAmount()"
        [sourceAddendumLabel]="dealAddendum().builderReference.reference"
        (formSaved)="onReallocationSaved()"
        (formDismiss)="onReallocationDismiss()"
      />

      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
          <p-button label="Dismiss — leave in pool" severity="secondary" (onClick)="onReallocationDismiss()" />
          <p-button
            [label]="reallocationForm?.submitButtonLabel() ?? 'Reallocate'"
            [disabled]="reallocationForm?.isSubmitDisabled() ?? true"
            (onClick)="reallocationForm?.submit()"
          />
        </div>
      </ng-template>
    </p-dialog>
  }

  <!-- Guarded so the preview request only fires when the dialog opens. -->
  @if (isRoomReplacementRerunModalVisible()) {
    <p-dialog
      header="Apply location rules"
      [visible]="isRoomReplacementRerunModalVisible()"
      (visibleChange)="closeRoomReplacementRerunModal()"
      [modal]="true"
      [draggable]="false"
      [style]="{ width: '90vw', maxWidth: '560px' }"
      [appendTo]="'body'"
    >
      <dsm-room-replacement-rerun
        [addendum]="dealAddendum()"
        (rerun)="onRoomReplacementRerun()"
        (dialogClose)="closeRoomReplacementRerunModal()"
      />
    </p-dialog>
  }

  <p-confirmdialog />
}
